import { Upload } from 'lucide-react'
import { type ChangeEvent, useCallback } from 'react'
import { cn } from '#app/utils/misc.js'
import { useDropZone, useUploader } from './hooks'

export const ImageUploader = ({
	onUpload,
}: {
	onUpload: (url: string) => void
}) => {
	const { loading, uploadFile } = useUploader({ onUpload })
	const { draggedInside, onDrop, onDragEnter, onDragLeave } = useDropZone({
		uploader: uploadFile,
	})

	const onFileChange = useCallback(
		(e: ChangeEvent<HTMLInputElement>) =>
			e.target.files ? uploadFile(e.target.files[0]) : null,
		[uploadFile],
	)

	const wrapperClass = cn(
		'flex flex-col aspect-video gap-3 cursor-pointer hover:bg-primary hover:border-primary/50 border-border bg-primary-foreground items-center justify-center px-8 py-10 rounded-lg transition-all ease-in-out duration-200 border border-dashed',
	)

	return (
		<div
			className={wrapperClass}
			onDrop={onDrop}
			onDragOver={onDragEnter}
			onDragLeave={onDragLeave}
			contentEditable={false}
		>
			<label
				className={`${loading ? 'blur-sm' : 'blur-none'} flex h-full w-full cursor-pointer flex-col items-center justify-center gap-3 transition-all duration-200 ease-in-out`}
				htmlFor="uploadFile"
			>
				<Upload width={20} className="!text-label" />
				{draggedInside ? (
					<p className="!text-label">Drop your file here</p>
				) : (
					<p className="!text-label">
						Select or drag & drop any .jpg, .jpeg, .png, .webp, .gif
					</p>
				)}
				<input
					id="uploadFile"
					className="h-0 w-0 overflow-hidden opacity-0"
					type="file"
					accept=".jpg, .jpeg, .png, .webp, .gif"
					onChange={onFileChange}
				/>
			</label>
		</div>
	)
}

export default ImageUploader
